import i18n from "../../../i18n/index";
import ShippinFeeService from '../../../services/shippinFee/ShippinFee.js'

export default {
    data() {
        return {

            shippinFee: [],
            searchShippin: "",
            pagination: {},
            rowsPerPageItems: [5, 10, 15, 20],
            loading: true,
            total: 0,
            headers: [{
                    text: i18n.t('headers.provider'),
                    sortable: false,
                    value: "name"
                },
                {
                    text: i18n.t('headers.branch'),
                    sortable: false,
                    value: "providerId"
                },
                {
                    text: i18n.t('headers.coverage-area'),
                    sortable: false,
                    value: "type"
                },
                {
                    text: i18n.t('headers.range'),
                    sortable: false,
                    value: "type"
                }, {
                    text: i18n.t('headers.fee'),
                    sortable: false,
                    value: "type"
                }, {
                    text: 'ESTADO',
                    sortable: false,
                    value: "active"
                }
            ]
        }
    },
    watch: {
        pagination: {
            handler() {
                this.getShippinFee();
            },
            deep: true
        }
    },
    methods: {
        showDetail(item) {
            this.$emit("showDetail", item)
            this.disableupdate = true;
        },
        getShippinFee() {
            const { page, rowsPerPage } = this.pagination;
            ShippinFeeService.search(page - 1, rowsPerPage, this.searchShippin)
                .then(resp => {
                    this.loading = false;
                    this.shippinFee = resp.data[0];
                    this.total = resp.data[1]
                });
        },
        customFilter(items, search, filter) {

            search = search.toString().toLowerCase()
            return items.filter(row => filter(row.idBranch.name, search));

        }
    },

    mounted() {
        this.getShippinFee()
    },

}